import { render } from "./brandList.vue?vue&type=template&id=e3e83754&scoped=true"
import script from "./brandList.vue?vue&type=script&lang=js"
export * from "./brandList.vue?vue&type=script&lang=js"

import "./brandList.vue?vue&type=style&index=0&id=e3e83754&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e3e83754"]])

export default __exports__